import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stock-in-range',
  templateUrl: './stock-in-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockInRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
